import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { LoginService } from '../login/services/login.service';
import { CoreService, CustomerUser } from '../services/core.service';
import { TournamentsService } from './../tournaments/services/tournaments.service';
import { translationHelper } from '~/helpers/translation.helper';
declare let $;
declare let SetLanguage: any;
declare let _sendChromeMessage: any;

declare let Print_CloseCashbox_Ticket: any;
declare let Print_CheckCashbox_Ticket: any;

@Component({
    selector: 'comp_settingsPassword_modal',
    templateUrl: './settingsPassword_Modal.html',
})
export class SettingsPassword implements OnInit {
    public passwordValue = '';
    public moneyReaderActive = '';
    public moneyReaderPassive = 'disabled';
    public DateErrorVisible = 0;
    public SettingLogin_Input_Value = '';
    public init: boolean;
    constructor(
        public tournamentsService: TournamentsService,
        private loginService: LoginService,
        public coreService: CoreService,
        public _translate: translationHelper,
    ) {}
    public ngOnInit() {
        this.DateErrorVisible = 0;
        if (this.init) {
            return;
        }
        this.init = true;
        this.SettingLogin_Input_Value = '';

        $('.tabular.menu .item').tab();

        this.IsAnonymousBet_CheckBox_Load();
    }
    public getTerminalKeyBoardValue(e) {
        // console.log("passwordvalue", e);
        // this.passwordValue = e;
    }
    public OpenTerminalKeyboardModal() {
        $('#Terminal_Keyboard_Modal')
            .modal({
                allowMultiple: true,
            })
            .modal('show');
    }
    public PasswordControl() {
        this.tournamentsService.getSettingPassword_Terminal(
            $('input[name="__RequestVerificationToken"]').val(),
            this.tournamentsService.KeyboardValue,
        );
    }
    public SettingLogin_ChangeValue(e) {
        this.SettingLogin_Input_Value += e;
    }

    public SettingLogin_Ok() {
        if (this.SettingLogin_Input_Value != '') {
            this.tournamentsService.KeyboardValue = this.SettingLogin_Input_Value;
            this.tournamentsService.getSettingPassword_Terminal(
                $('input[name="__RequestVerificationToken"]').val(),
                this.tournamentsService.KeyboardValue,
            );
        }
        this.SettingLogin_Input_Value = '';
    }
    public SettingLogin__Cancel() {
        this.SettingLogin_Input_Value = this.SettingLogin_Input_Value.slice(0, -1);
    }

    public PrintLastSlipDetail() {
        this.tournamentsService.getPrintLastSlipDetail($('input[name="__RequestVerificationToken"]').val());
    }
    public SettingLogin_Close() {
        this.SettingLogin_Input_Value = '';
        this.tournamentsService.SettingPasswordErrorVisible = 0;
        $('#SettingPasswordModalLogin').modal('hide');
    }

    public MoneyReaderActiveDisable() {
        this.moneyReaderPassive = '';
        this.moneyReaderActive = 'disabled';
    }
    public MoneyActiveButton() {
        // _sendChromeMessage("runmoneyreader");
        _sendChromeMessage({
            command: 'runmoneyreader',
        });
        setTimeout(() => this.MoneyReaderActiveDisable(), 3000);
    }
    public MoneyReaderRestartButton() {
        _sendChromeMessage({
            command: 'restartmoneyreader',
        });
    }
    public MoneyReaderStopDisable() {
        this.moneyReaderPassive = 'disabled';
        this.moneyReaderActive = '';
    }
    public MoneyReader_Stop_Button() {
        // haltmoneyreader
        // _sendChromeMessage("haltmoneyreader");
        _sendChromeMessage({
            command: 'haltmoneyreader',
        });
        setTimeout(() => this.MoneyReaderStopDisable(), 3000);
    }
    public SignOutTerminal() {
        _sendChromeMessage({
            command: 'clearCredentials',
        });
        $('#settingTerminal_Modal').modal('hide');
        this.loginService.singOut(this.coreService.customerUser);
        this.coreService.customerUser.IsLogged = false;
        this.loginService.LoginState = 0;
        window.location.reload();
    }
    public CloseCashBox() {
        $('#CashboxClosedYesNo')
            .modal({
                allowMultiple: true,
            })
            .modal('show');
    }
    public ExitCheckCashBoxModel() {
        $('#CheckCashBoxModal').modal('hide');
    }
    public ExitCheckCashBoxDateModal() {
        $('#CheckCashBoxDateModal').modal('hide');
    }
    public CheckCashBox() {
        this.tournamentsService.getCheckCashBox_Terminal();
    }
    public ExitCashBoxModel() {
        $('#closeCashBoxModal').modal('hide');
    }
    public PrintCashBoxModel() {
        // $('#printCloseBoxTable').modal('show');
        Print_CloseCashbox_Ticket();
        $('#closeCashBoxModal').modal('hide');
    }
    public PrintCheckCashBoxModel() {
        Print_CheckCashbox_Ticket();
    }
    public PrintCheckCashBoxDateModel() {
        $('#CheckCashBoxDateModal').modal('hide');
        Print_CheckCashbox_Ticket();
    }
    public CashBoxClosedYes() {
        this.tournamentsService.getCloseCashBox_Terminal();
    }
    public CashBoxClosedNo() {
        $('#CashboxClosedYesNo').modal('hide');
    }
    public ExitCashBoxYesNo() {
        $('#CashboxClosedYesNo').modal('hide');
    }
    public PrintLastSlip() {
        this.tournamentsService.getPrintLastSlip();
    }
    public PrintLastPayout() {
        // this.tournamentsService.getPrintLastPayout();
        this.tournamentsService.payoutPayConfirmButton = 1;
        $('#settingTerminal_Modal').modal('hide');
        $('#ReadPayoutSlip')
            .modal({
                // detachable: true,
                allowMultiple: true,
            })
            .modal('show');
    }
    public CheckCashBoxDate() {
        this.tournamentsService.checkCashBoxList = [];
        // $('#CheckBoxSelectDate')
        //  .modal({
        //    allowMultiple: true
        //  }).modal('show');
    }
    public ExitCheckBoxSelectDate() {
        $('#CheckBoxSelectDate').modal('hide');
    }
    public SendCheckBoxDate() {
        if (
            (document.getElementById('CbStartDate') as HTMLInputElement).value == '' ||
            (document.getElementById('CbEndDate') as HTMLInputElement).value == ''
        ) {
            this.DateErrorVisible = 1;
        } else {
            this.DateErrorVisible = 0;
            this.tournamentsService.getCheckCashBoxDate_Terminal(
                (document.getElementById('CbStartDate') as HTMLInputElement).value,
                (document.getElementById('CbEndDate') as HTMLInputElement).value,
            );
        }
    }

    public Exit_Settings_Modal() {
        $('#settings_Modal_2').modal('hide');
    }

    IsAnonymousBet_CheckBox_Load() {
        const comp = this as SettingsPassword;
        $('#IsAnonymousBet_CheckBox').checkbox({
            // check all children
            onChecked: function() {
                console.log('onChecked');

                _sendChromeMessage({
                    command: 'haltmoneyreader',
                });

                comp.UpdateIsAnonymous(1);
            },
            // uncheck all children
            onUnchecked: function() {
                console.log('onUnchecked');
                comp.UpdateIsAnonymous(0);
            },
        });
    }

    UpdateIsAnonymous(isActive) {
        this.tournamentsService.terminalUpdateIsAnonymousBet(isActive).then(x => {
            // console.log(x);
        });
    }

    RunMoney() {
        _sendChromeMessage({
            command: 'runmoneyreader',
        });
    }

    HaltMoney() {
        _sendChromeMessage({
            command: 'haltmoneyreader',
        });
    }

    RestartMoney() {
        _sendChromeMessage({
            command: 'restartmoneyreader',
        });
    }

    HaltMoney2() {
        _sendChromeMessage({
            command: 'haltmoneyreader2',
        });
    }
}
